'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var ComboBoxBase = require('../common/ComboBoxBase');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-29
 @Descript : 下拉列表框组件
 */
var CompositeComboBox = React.createClass({

  parseText: function () {
    var arr = util.Text.delimitToParagraphs(styleHelper.getText(this.props.items[2]));
    var i;
    for (i = 0; i < arr.length; i++) {
      arr[i] = util.Text.convertSpaceToNbsp(arr[i]);
    }
    return arr;
  },

  render: function () {
    var textItems = this.parseText();
    var props = {
      items: textItems,
      borderColor: this.props.borderColor,
      color: this.props.textColor,
      backgroundColor: this.props.color,
      fontSize: this.props.textSize,
      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family),
      selectedIndex: this.props.items[2].selectedIndex,
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      canInput: this.props.canInput,
      onItemClick: this.onItemClick
    };

    if (this.props.textStyles) {
      props.fontWeight = this.props.textStyles.fontWeight;
      props.fontStyle = this.props.textStyles.fontStyle;
      props.textDecoration = this.props.textStyles.textDecoration;
    }
    return (
      <ComboBoxBase ref="combobox" {...props}/>
    );
  },
  onItemClick: function (e, index) {
    var props = this.props.items[2];
    var links = props.links;
    var interactiveData = props.interactiveData;
    var link = links.link[index];
    var entry = interactiveData.entry[index];
    var action = appTypes.ActionResponseType.NONE;
    if(props.hasOwnProperty('externalURL') && props.externalURL !== ''){
      action = appTypes.ActionResponseType.OUTER;
    }else if(link.targetPageID !== '' && link.linkType === 'ltPageLink'){
      action = appTypes.ActionResponseType.LINK;
    }else if(entry.events && entry.events){
      action = appTypes.ActionResponseType.INTERACTIVE;
    }
    this.props.events.doSelfClick(e, props, action, index);
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
  },

  onResize: function (e) {
    $(ReactDOM.findDOMNode(this.refs.combobox)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
  }

});

module.exports = CompositeComboBox;



// WEBPACK FOOTER //
// ./src/views/Components/CompositeComboBox.jsx